var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3787 10.4822C10.9413 9.91959 11.7044 9.60352 12.5 9.60352H13.5C14.0523 9.60352 14.5 10.0512 14.5 10.6035V14.6035C14.5 15.1558 14.9477 15.6035 15.5 15.6035H21.5C22.0523 15.6035 22.5 15.1558 22.5 14.6035V10.6035C22.5 10.0512 22.9477 9.60352 23.5 9.60352H25.5L30.3284 14.4319C31.0786 15.1821 31.5 16.1995 31.5 17.2604V28.6035C31.5 29.3991 31.1839 30.1622 30.6213 30.7248C30.0587 31.2874 29.2956 31.6035 28.5 31.6035H12.5C10.8431 31.6035 9.5 30.2604 9.5 28.6035V12.6035C9.5 11.8079 9.81607 11.0448 10.3787 10.4822Z",
    fill: "url(#paint0_linear_162_423)",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.6035V12.6035C9.5 11.8079 9.81607 11.0448 10.3787 10.4822C10.9413 9.91959 11.7044 9.60352 12.5 9.60352H13.5C14.0523 9.60352 14.5 10.0512 14.5 10.6035V14.6035C14.5 15.1558 14.9477 15.6035 15.5 15.6035H21.5C22.0523 15.6035 22.5 15.1558 22.5 14.6035V10.6035C22.5 10.0512 22.9477 9.60352 23.5 9.60352H24.6716C25.202 9.60352 25.7107 9.81423 26.0858 10.1893L30.3284 14.4319C31.0786 15.1821 31.5 16.1995 31.5 17.2604V21.6035V28.6035C31.5 29.3991 31.1839 30.1622 30.6213 30.7248C30.0587 31.2874 29.2956 31.6035 28.5 31.6035H23.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 29.8535C13.75 29.8535 13.75 24.6035 13.75 24.6035C13.75 24.6035 13.75 29.8535 18 29.8535C13.75 29.8535 13.75 35.1035 13.75 35.1035C13.75 35.1035 13.75 29.8535 9.5 29.8535Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 24.8535C7.75 24.8535 7.75 22.6035 7.75 22.6035C7.75 22.6035 7.75 24.8535 10 24.8535C7.75 24.8535 7.75 27.1035 7.75 27.1035C7.75 27.1035 7.75 24.8535 5.5 24.8535Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 33.1035H7.51M18 22.6035H18.01M18 35.1035H18.01M13.75 24.6035C13.75 24.6035 13.75 29.8535 9.5 29.8535C13.75 29.8535 13.75 35.1035 13.75 35.1035C13.75 35.1035 13.75 29.8535 18 29.8535C13.75 29.8535 13.75 24.6035 13.75 24.6035ZM7.75 22.6035C7.75 22.6035 7.75 24.8535 5.5 24.8535C7.75 24.8535 7.75 27.1035 7.75 27.1035C7.75 27.1035 7.75 24.8535 10 24.8535C7.75 24.8535 7.75 22.6035 7.75 22.6035Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M20 9.60352H19C18.7239 9.60352 18.5 9.82737 18.5 10.1035V13.1035C18.5 13.3797 18.7239 13.6035 19 13.6035H20C20.2761 13.6035 20.5 13.3797 20.5 13.1035V10.1035C20.5 9.82737 20.2761 9.60352 20 9.60352Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_162_423",
    x1: 20.5,
    y1: 9.60352,
    x2: 20.5,
    y2: 31.6035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.ce8b1ea68f81b1dc2dd7f0c12f490384.svg";
export { ForwardRef as ReactComponent };